export const addContractedLine = (contractedAmount, data, name)=> {
  let contracted = data?.trend?.data[name] || []
  contracted = contracted.map(item => [item[0], contractedAmount])
  data.trend.data = { contracted: contracted, ...data.trend.data}
  return data
}
